import { PayloadAction, createSlice } from '@reduxjs/toolkit'
import { TransformationTemplate } from '@/types/WorkflowCreate/transformation'

interface TransformationInitialState {
  templates: TransformationTemplate[]
}

const initialState: TransformationInitialState = {
  templates: [],
}

const setTransformationTemplates = (
  state: TransformationInitialState = initialState,
  action: PayloadAction<TransformationTemplate[]>
) => {
  return {
    ...state,
    templates: action.payload
  }
}

const transformationSlice = createSlice({
  name: 'transformations',
  initialState,
  reducers: {
    setTransformationTemplates
  }
})

export const transformationReducer = transformationSlice.reducer
export const transformationActions = transformationSlice.actions
